"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { getEvents } from "@/services/event-services"
import { useDomainStore } from "@/stores/use-domain-store"
import dayjs from "dayjs"
import { useParams } from "next/navigation"
import { useEffect, useMemo, useState } from "react"
import type { EventItem } from "../types"
import { mapEventToItem } from "../utils/utils"

export const useEvents = (pageSize: number = 10) => {
  const selectedDomain = useDomainStore(state => state.selectedDomain)

  const [events, setEvents] = useState<EventItem[]>([])
  const [loading, setLoading] = useState(true)
  const currentDomainName = selectedDomain?.attributes?.domain || ""
  const params = useParams()
  const storeLocale = useUIBuilderLocaleStore(state => state.locale)
  // Public có params.locale, editor thì không -> rơi về locale của blockContent đang sửa.
  const locale = (params?.locale as string) || storeLocale || "vi"

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true)
        const response = await getEvents({
          pagination: {
            pageSize: pageSize * 2,
          },
          publicationState: "live",
          domain: currentDomainName,
          locale,
        })
        if (response?.data) {
          const mappedEvents = response.data.map(mapEventToItem)
          setEvents(mappedEvents)
        }
      } catch (error) {
        console.error("Error fetching events:", error)
        setEvents([])
      } finally {
        setLoading(false)
      }
    }

    fetchEvents()
  }, [pageSize, locale, currentDomainName])

  const upcomingEvents = useMemo(() => {
    const today = dayjs().startOf("day")
    return events
      .filter(event => {
        if (!event.date) return false
        const eventDate = dayjs(event.date).startOf("day")
        return eventDate.isAfter(today) || eventDate.isSame(today)
      })
      .slice(0, pageSize)
  }, [events, pageSize])

  return { events: upcomingEvents, loading }
}
